import Vue from 'vue'
import Router from 'vue-router'
import TitanHome from '@/components/TitanHome'
import TitanTicket from '@/components/TitanTicket'
import TitanLogin from '@/components/TitanLogin'
import TitanMyTickets from '@/components/TitanMyTickets'
import TitanReprint from '@/components/TitanReprint'
import TitanCashflow from '@/components/TitanCashflow'
import TitanPIXQRCode from '@/components/TitanPIXQRCode'
import TitanRoulette from '@/components/TitanRoulette'
import TitanClientRegister from '@/components/TitanClientRegister'
import TitanClientLogin from '@/components/TitanClientLogin'
import TitanClientDeposit from '@/components/TitanClientDeposit'
import TitanClient from '@/components/TitanClient'
import TitanClientStatement from '@/components/TitanClientStatement'
import TitanCards from '@/components/TitanCards'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'TitanHome',
      component: TitanHome
    },
    {
      path: '/ticket/:id',
      name: 'TitanTicket',
      component: TitanTicket
    },
    {
      path: '/login',
      name: 'TitanLogin',
      component: TitanLogin
    },
    {
      path: '/mytickets',
      name: 'TitanMyTickets',
      component: TitanMyTickets
    },
    {
      path: '/reprint/:id',
      name: 'TitanReprint',
      component: TitanReprint
    },
    {
      path: '/cashflow',
      name: 'TitanCashflow',
      component: TitanCashflow
    },
    {
      path: '/pixqrcode/:id',
      name: 'TitanPIXQRCode',
      component: TitanPIXQRCode
    },
    {
      path: '/roulette',
      name: 'TitanRoulette',
      component: TitanRoulette
    },
    {
      path: '/client-register/:partnerid?',
      name: 'TitanClientRegister',
      component: TitanClientRegister
    },
    {
      path: '/client-login',
      name: 'TitanClientLogin',
      component: TitanClientLogin
    },
    {
      path: '/client-deposit/:id',
      name: 'TitanClientDeposit',
      component: TitanClientDeposit
    },
    {
      path: '/client',
      name: 'TitanClient',
      component: TitanClient
    },
    {
      path: '/client-statement',
      name: 'TitanClientStatement',
      component: TitanClientStatement
    },
    {
      path: '/cards',
      name: 'TitanCards',
      component: TitanCards
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js